import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoginForm from '../components/auth/LoginForm';
import SwitchOnSplit from '../components/auth/login/SwitchOnSplit';
import { Card, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { User } from 'lucide-react';

/* ── Auth ── */
export function LoginPage() {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) return null;
  if (isAuthenticated) return <Navigate to="/" replace />;
  return (
    <SwitchOnSplit>
      <LoginForm />
    </SwitchOnSplit>
  );
}

export function ForgotPasswordPage() {
  return (
    <Card className="max-w-lg mx-auto mt-12" data-testid="page-forgot-password">
      <CardHeader className="text-center">
        <User className="w-12 h-12 mx-auto text-muted-foreground/40 mb-2" />
        <CardTitle>Forgot Password</CardTitle>
        <CardDescription>Contact your administrator to reset your password.</CardDescription>
      </CardHeader>
    </Card>
  );
}

/* ── Re-exports from individual page files (post-pivot: trainer-led only) ── */
export { default as ModulePlayerPage } from './ModulePlayerPage';
export { default as ProfilePage } from './ProfilePage';
export { default as ModuleEditorListPage } from './EditorModuleListPage';
export { default as ModuleEditorPage } from './ModuleEditorPage';
export { default as UploadPage } from './UploadPage';
export { default as ModuleAnalyticsPage } from './ModuleAnalyticsPage';
